import React, { useState, useEffect, useRef } from "react";

const CKEditorWrapper = ({ value, onChange, config }) => {
  const [CKEditorComponent, setCKEditorComponent] = useState(null);
  const [loading, setLoading] = useState(true);
  const editorClassRef = useRef(null);

  useEffect(() => {
    // Try to dynamically import CKEditor
    const loadCKEditor = async () => {
      try {
        const ckeditorReact = await import("@ckeditor/ckeditor5-react");
        const ckeditorBuild = await import("@ckeditor/ckeditor5-build-classic");
        
        // Store the component and editor class properly
        const EditorComponent = ckeditorReact.CKEditor || ckeditorReact.default;
        const EditorClass = ckeditorBuild.default || ckeditorBuild;
        
        // Store editor class in ref to avoid React state issues with class constructors
        editorClassRef.current = EditorClass;
        setCKEditorComponent(() => EditorComponent);
      } catch (e) {
        // CKEditor not installed - will use textarea fallback
        console.warn("CKEditor packages not found. Using textarea fallback.");
      } finally {
        setLoading(false);
      }
    };

    loadCKEditor();
  }, []);

  if (loading) {
    return (
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="form-control form-control-sm"
        rows="15"
        placeholder="Loading editor..."
      />
    );
  }

  if (CKEditorComponent && editorClassRef.current) {
    return (
      <div style={{ minHeight: '400px' }}>
        <style>
          {`
            .ck-editor__editable {
              min-height: 400px !important;
            }
          `}
        </style>
        <CKEditorComponent
          editor={editorClassRef.current}
          data={value || ""}
          onChange={(event, editor) => {
            const data = editor.getData();
            onChange(data);
          }}
          config={config || {
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "|",
              "blockQuote",
              "insertTable",
              "|",
              "undo",
              "redo",
            ],
          }}
        />
      </div>
    );
  }

  // Fallback to textarea
  return (
    <div>
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="form-control form-control-sm"
        rows="15"
        placeholder="Description... (Install CKEditor packages for rich text editing)"
      />
      <small className="text-muted d-block mt-1">
        Note: Install CKEditor packages for rich text editing. Run: npm install @ckeditor/ckeditor5-react @ckeditor/ckeditor5-build-classic
      </small>
    </div>
  );
};

export default CKEditorWrapper;
